<template>
  <AppPage :title="'Your Account (' + this.user.email + ')'"
    iconName="person"
    :dirty="dirty"
    :buttons="buttons"
    :message="message"
    :tempMessage="info"
    :workingDialog="workingDialog"
    v-on:app-page-button-click="handleAppPageButtonClick"
  >
    <v-container fluid>
      <UserForm
        ref="userForm"
        :value="editted"
        mode="account"
        @input="updateUser($event)"
      ></UserForm>
    </v-container>
    <UpgradeDialog ref="upgradeDialog"></UpgradeDialog>
  </AppPage>
</template>

<script>
import { mapState } from 'vuex'
import { ExceptionMessage, WARNING_ICON } from '@itus/ui.common'
import AppPage from '@/components/AppPage'
import UserForm from '@/components/UserForm'
import UpgradeDialog from '@/components/UpgradeDialog'
import { handleRouterError } from '@/router'
import { UserModel } from '@/user-model'

export default {
  name: 'Account',
  components: {
    AppPage,
    UserForm,
    UpgradeDialog
  },
  data() {
    return {
      message : { show: false, type: 'error', text: '' },
      info :  { type: 'success', show: false, text: '' },
      workingDialog: { show: false },
      editted: null,
      original: null
    }
  },
  computed: {
    ...mapState({
      user: state => state.user
    }),
    buttons() {
      let items = [{id: 'save', title: 'Save', icon:'save' , hasSub: false, disabled: !this.dirty}]
      items.unshift({ id: 'resetpassword', title: 'Reset Password', icon: 'security', hasSub: false, disabled: false })

      return items
    },
    dirty() {
      return JSON.stringify(this.editted) !== this.original
    }
  },
  methods : {
    refreshAfterDowngrade() {
      this.original = JSON.stringify(this.editted)
    },
    updateUser(newData) {
      this.editted = newData
    },
    showException(err, defaultMsg) {
      this.message = ExceptionMessage.generateMessage(err, defaultMsg)
    },
    async save() {
      if (!this.$refs.userForm.validate())
        return

      try {
        this.workingDialog.show = true
        await this.$store.dispatch('updateUser', this.editted)
        this.original = JSON.stringify(this.editted)
      } catch(err) {
        this.showException(err, 'Error: Unable to update account settings.')
      } finally {
        this.workingDialog.show = false
      }
    },
    async handleAppPageButtonClick(buttonId) {
      if(buttonId === 'save') {
        await this.save()
      } else if(buttonId === 'resetpassword') {
        if (this.dirty && !await this.showUnsavedChanges())
          return

        let confirmChange = await this.$root.$confirm('Reset Password','Do you want to reset your password?',{
          warning:false,
          icon:"security",
          noText: 'Cancel',
          yesText: 'Send Reset Link'
        })

        if(confirmChange) {
          try {
            this.workingDialog.show = true
            await this.$store.dispatch('requestResetPassword', { email: this.editted.email } )
            this.info = { show: true, type: 'info', text: 'Check your email for a password reset link.' }
          } catch(err) {
            this.showException(err, 'Error: Unable to request password reset.')
          } finally {
            this.workingDialog.show = false
          }
        }
      } else if (buttonId === 'upgradeAccount') {
        await this.$refs.upgradeDialog.show()
        await this.initUser()
      } else if (buttonId === 'downgradeAccount') {
        await this.$refs.downgradeDialog.show()
        await this.initUser()
      } else if (buttonId === 'updatePaymentMethod') {
        await this.$refs.paymentDialog.show({mode:'paymentUpdate'})
        await this.initUser()
      }
    },
    async initUser(){
      try{
        this.workingDialog.show = true
        await this.$store.dispatch('loadUser')
        this.editted = new UserModel(this.user)
        this.original = JSON.stringify(this.editted)
      }
      catch(err){this.showException(err, 'Error: Unable to load user from store.')}
      finally{this.workingDialog.show = false}

    },
    showUnsavedChanges() {
      return this.$root.$confirm('Unsaved Changes', 'If you change your password, you will be logged out and your unsaved changes will be discarded.',{
        warning: true,
        icon: WARNING_ICON,
        noText: 'Cancel',
        yesText: 'Continue'
      })
    },
    logout() {
      this.$router.push('/signout').catch(handleRouterError)
    }
  },
  mounted() {
    this.initUser()
  },
  beforeRouteUpdate(to, from, next) {
    this.$children[0].beforeRouteLeave(to, from, next)
  },
  async beforeRouteLeave(to, from, next) {
    this.$children[0].beforeRouteLeave(to, from, next)
  }
}
</script>